import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-catalogue",
  "use": "icon-catalogue-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 14 14\" id=\"icon-catalogue\"><rect width=\"10\" height=\"11\" x=\"2\" y=\"1.5\" stroke=\"#FFE17F\" opacity=\".6\" rx=\"1.5\" /><path stroke=\"#FDBC26\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.5 4.5h5M4.5 7h5m-5 2.5h3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol